@if (packagesAvailable) {
    <div class="bingo-packages-data-container">
        <div class="bingo-packages-data" [class.no-filter-items]="!(filteredPackageItems && filteredPackageItems.length > 0)">
            <div class="bingo-packages-data-body">
                <div class="packages-filter">
                    <span class="filter-text">{{ content.filter }}</span>
                    <bg-bingo-packages-filter
                        [packageFilterItems]="packageFilterItems"
                        [selectedFilterItem]="selectedFilterItem"
                        (selectItem)="filterOptionClicked($event)" />
                </div>
                @if (filteredPackageItems && filteredPackageItems.length > 0) {
                    <div class="packages-container">
                        @for (package of filteredPackageItems; track package.id) {
                            @if (!package.hideItem) {
                                <bg-bingo-package-item #packages [id]="package.id" [highlight]="package.id == deepLinkedPackageId" />
                            }
                        }
                    </div>
                }
            </div>
            @if (!(filteredPackageItems && filteredPackageItems.length > 0)) {
                <div class="no-filtered-packages-available">
                    <span>{{ content.NoPackages }}</span>
                </div>
            }
        </div>
    </div>
} @else {
    @if (packagesLoading) {
        <div class="no-packages-available">
            {{ content?.PackageLoading }}
        </div>
    } @else if (!packagesAvailable && !packagesLoading) {
        <div class="no-packages-available">
            {{ content.NoPackages }}
        </div>
    }
}
